import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["code", "parserOptions", "disableWrapper"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import parseHTML from 'html-react-parser';
import Wrapper from '../Wrapper';
import { withTitle } from '../../HOC';
import { getClassModifiers } from '../../utils';
import { CODE } from '../../constants';
import { wrapScriptTags } from './helpers';
const Code = memo(_ref => {
  let {
      code: embedCode,
      parserOptions,
      disableWrapper
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!embedCode) return null;
  const parsedCode = parseHTML(embedCode, parserOptions);
  const wrappedCode = wrapScriptTags(parsedCode);
  const modifiers = getClassModifiers(CODE, _objectSpread({}, otherProps));
  if (disableWrapper) return wrappedCode;
  return /*#__PURE__*/React.createElement(Wrapper, {
    modifiers: modifiers
  }, wrappedCode);
});
Code.propTypes = {
  code: PropTypes.string,
  modifier: PropTypes.string,
  parserOptions: PropTypes.object,
  disableWrapper: PropTypes.bool
};
Code.defaultProps = {
  code: '',
  modifier: '',
  parserOptions: {},
  disableWrapper: false
};
export default withTitle(Code);
//# sourceMappingURL=Code.js.map